module.exports = __webpack_public_path__ + "static/media/appointment.9c1ac6a3.svg";